import { safetyHandler } from './utils';

export const DeviceType = new Proxy(
  {
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
    DESKTOP: 'DESKTOP',
  },
  safetyHandler('DeviceType'),
);
